import { Component } from '@theme/component';
import { animate, stagger } from 'animejs';

/**
 * Animates hero media and content into view on load.
 *
 * @extends {Component}
 */
export class HeroAnimate extends Component {
  connectedCallback() {
    super.connectedCallback();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = this.querySelectorAll('.hero__media');
    const content = this.querySelectorAll('.hero__content-wrapper > *');

    animate(media, {
      opacity: [0, 1],
      scale: [1.05, 1],
      duration: 1000,
      ease: 'outQuad',
    });

    animate(content, {
      opacity: [0, 1],
      translateY: [24, 0],
      duration: 700,
      delay: stagger(90, { start: 200 }),
      ease: 'outQuad',
    });
  }
}

if (!customElements.get('hero-animate')) {
  customElements.define('hero-animate', HeroAnimate);
}
